import { StatusBadge } from "@swot/base-components";
import type { CmtsSession } from "@cmts/session/cmtsSessionTypes.js";
import { formatCmtsTenantDisplay } from "@cmts/session/cmtsTenantDisplay.js";

export function CmtsSessionBadge({ session }: { session: CmtsSession }) {
  const tenantLabel = formatCmtsTenantDisplay(session);
  return (
    <span className="cmts-session-badge" data-tenant-id={session.tenantId} data-tenant-name={session.tenantName} title={`${tenantLabel} · ${session.persona} · ${session.runtimeMode}`}>
      <StatusBadge label={tenantLabel} tone="info" />
      <small>{session.persona}</small>
    </span>
  );
}
